import { useMutation } from '@tanstack/react-query';

import { queryClient } from '@/lib/queryClient';
import PromptsService, { CreatePromptDto } from '@/services/PromptsService';

export function useCreatePrompt() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (createPromptDto: CreatePromptDto) =>
      PromptsService.createPrompt(createPromptDto),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['prompts'],
      });
      queryClient.invalidateQueries({
        queryKey: ['unique-values'],
      });
    },
  });

  return {
    createPrompt: mutateAsync,
    isLoading: isPending,
  };
}
